export const getStyled = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  extraAttr: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  buttonProgress: {
    color: theme.custom.colors.confirmButton,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },

  textCenter: {
    backgroundColor: 'red',
  },

  cancelButton: {
    backgroundColor: theme.custom.colors.cancelButton,
    color: '#FFF',
  },

  saveButton: {
    backgroundColor: theme.custom.colors.confirmButton,
    color: '#FFF',
  },
});
